/* eslint-disable no-console */

import { register } from 'register-service-worker';
import { Notification } from 'element-ui';
import i18n from './i18n';

if (process.env.NODE_ENV === 'production') {
  // Prevent infinite reload loop
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    // Wait 10 seconds before reloading to give user time to see the notification
    setTimeout(() => {
      window.location.reload();
    }, 10 * 1000);
  });

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n'
        + 'For more details, visit https://goo.gl/AFskqB',
      );
    },
    registered(registration) {
      console.log('Service worker has been registered.');

      // Check for updates every 5 minutes
      setInterval(() => {
        // Skip if already installing
        if (registration.installing) return;

        // Skip if offline
        if ('connection' in navigator && !navigator.onLine) return;

        console.log('Checking for service worker updates...');
        registration.update();
      }, 5 * 60 * 1000);
    },
    cached() {
      console.log('Content has been cached for offline use.');
    },
    updatefound() {
      console.log('New content is downloading.');
    },
    updated() {
      console.log('New content is available; please refresh.');

      // Show notification to user
      Notification({
        title: '',
        message: i18n.t('global.appUpdateAvailable'),
        type: 'info',
        duration: 10000,
        showClose: false,
      });
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.');
    },
    error(error) {
      console.error('Error during service worker registration:', error);
    },
  });
}
